/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `userGoal` - cel użytkownika
 * * `cushion` - poduszka finansowa
 */
export type GoalKindEnum = typeof GoalKindEnum[keyof typeof GoalKindEnum];


export const GoalKindEnum = {
  userGoal: 'userGoal',
  cushion: 'cushion',
} as const;
